import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setActionBtnTitle, setHeaderAction, setHeaderTitle } from 'features/ui/model/uiSlice';
import { CitiesWidget } from 'widgets/settings/CitiesWidget';

export const CitiesPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Города'));

    dispatch(setActionBtnTitle('Добавить'));
    dispatch(setHeaderAction('edit'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <CitiesWidget />;
};
